export default "__VITE_ASSET__fc4ebb1c__"